import React, { useEffect } from "react";
import "../sell-fast-page/info-page.css";
import { FaCheckCircle, FaEnvelope, FaShieldAlt, FaBolt } from "react-icons/fa";
import { EMAIL } from "../../../configs/website-information/websiteInfo";

const SECTIONS = [
  {
    title: "Who We Are",
    points: [
      "AdsOne.lk is Sri Lanka's dedicated vehicle marketplace — built to make buying and selling cars, vans, trucks and bikes simple, safe and transparent.",
      "We connect thousands of buyers and sellers island-wide, offering a trusted platform where every listing is reviewed before it goes live.",
    ],
  },
  {
    title: "For Sellers",
    points: [
      "Posting an ad on AdsOne is completely free. Sign up, fill in your vehicle details, upload photos and your listing goes live after a quick review — usually within hours.",
      "Want more visibility? Our boost and premium promotion options put your ad at the top of search results and in front of more buyers.",
    ],
  },
  {
    title: "For Buyers",
    points: [
      "Browse thousands of verified vehicle listings across all categories. Use our filters to narrow by make, model, price, location and mileage to find exactly what you need.",
      "Every seller on AdsOne goes through a verification process. Trusted Member badges help you identify our most reliable sellers at a glance.",
    ],
  },
  {
    title: "Our Commitment",
    points: [
      "Every ad is manually reviewed by our team before publication. We do not allow misleading listings, stolen vehicles or fraudulent content.",
      "We take user privacy seriously. Your personal details are never shared publicly — buyers contact sellers only through our platform's messaging features.",
    ],
  },
  {
    title: "Get in Touch",
    points: [
      `Have a question, a concern or want to advertise with us? Reach our team at ${EMAIL}. We respond within one business day.`,
      "Support hours: 9 am – 6 pm on weekdays, 8 am – 5 pm on weekends and mercantile holidays.",
    ],
  },
];

const HIGHLIGHTS = [
  { icon: <FaCheckCircle size={20} color="#ed1b24" />, label: "Verified Listings" },
  { icon: <FaBolt         size={20} color="#ed1b24" />, label: "Fast Approvals"   },
  { icon: <FaShieldAlt   size={20} color="#ed1b24" />, label: "Trusted Sellers"  },
  { icon: <FaEnvelope    size={20} color="#ed1b24" />, label: "Dedicated Support" },
];

function AboutUsPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          {/* Hero */}
          <div className="info-page__hero">
            <p className="info-page__eyebrow">About Us</p>
            <h1 className="info-page__title">Sri Lanka's Vehicle Marketplace</h1>
            <p className="info-page__subtitle">
              AdsOne.lk is built for buyers and sellers who want a fast, transparent
              and trustworthy way to trade vehicles across Sri Lanka.
            </p>
          </div>

          {/* Highlights row */}
          <div style={{ padding: "2rem 2.5rem 0", display: "flex", gap: "1.5rem", flexWrap: "wrap", justifyContent: "center" }}>
            {HIGHLIGHTS.map((h, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: "0.5rem", fontSize: "0.9rem", fontWeight: 600, color: "#1e293b" }}>
                {h.icon} {h.label}
              </div>
            ))}
          </div>

          {/* Body sections */}
          <div className="info-page__body">
            {SECTIONS.map((section, i) => (
              <div key={i} className="info-section" style={{ flexDirection: "column", gap: "0.5rem" }}>
                <h3 className="info-section__title" style={{ marginBottom: 0 }}>
                  {section.title}
                </h3>
                <ul className="info-section__list">
                  {section.points.map((p, j) => (
                    <li key={j} style={{ alignItems: "flex-start" }}>
                      <span style={{ color: "#ed1b24", fontWeight: 700, flexShrink: 0, marginTop: 1 }}>—</span>
                      {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Footer note */}
          <div style={{ padding: "0 2.5rem 2rem", color: "#94a3b8", fontSize: "0.8125rem" }}>
            AdsOne.lk — Sri Lanka's trusted vehicle marketplace. Contact us at {EMAIL}
          </div>

        </div>
      </div>
    </div>
  );
}

export default AboutUsPage;
